import React, { useState } from 'react';
import { FormControl, Button, ButtonGroup } from 'react-bootstrap';
import { Search, XSquare } from 'react-bootstrap-icons';

function FiltrosClientes({ onFilterChange }) {
    const [filters, setFilters] = useState({
        clienteID: '',
        nomCliente: '',
        numCliente: '',
        correo: '',
        departamento: '',
        ciudad: '',
        direccion: ''
    });

    const handleChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value
        });
    };

    const handleSearch = () => {
        const cleanedFilters = {
            clienteID: filters.clienteID.trim(),
            nomCliente: filters.nomCliente.trim(),
            numCliente: filters.numCliente.trim(),
            correo: filters.correo.trim(),
            departamento: filters.departamento.trim(),
            ciudad: filters.ciudad.trim(),
            direccion: filters.direccion ? filters.direccion.trim() : ''
        };
        onFilterChange(cleanedFilters);
    };

    const handleClear = () => {
        const emptyFilters = {
            clienteID: '',
            nomCliente: '',
            numCliente: '',
            correo: '',
            departamento: '',
            ciudad: '',
            direccion: ''
        };
        setFilters(emptyFilters);
        onFilterChange(emptyFilters);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className='d-flex flex-wrap align-items-center m-3 gap-2'>
            <FormControl
                name='clienteID'
                placeholder='Busca por Identificación'
                style={{ minWidth: '150px', flex: '1 1 140px' }}
                value={filters.clienteID}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            <FormControl
                name='nomCliente'
                placeholder='Busca por Nombre'
                style={{ minWidth: '150px', flex: '1 1 140px' }}
                value={filters.nomCliente}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            <FormControl
                name='numCliente'
                placeholder='Busca por Celular'
                style={{ minWidth: '140px', flex: '1 1 130px' }}
                value={filters.numCliente}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            <FormControl
                name='correo'
                placeholder='Busca por Correo'
                style={{ minWidth: '150px', flex: '1 1 140px' }}
                value={filters.correo}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            <FormControl
                name='departamento'
                placeholder='Busca por Dep.'
                style={{ minWidth: '120px', flex: '1 1 110px' }}
                value={filters.departamento}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            <FormControl
                name='ciudad'
                placeholder='Busca por Ciudad'
                style={{ minWidth: '120px', flex: '1 1 110px' }}
                value={filters.ciudad}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            <ButtonGroup className='ms-auto'>
                <Button variant='danger' title='Buscar' onClick={handleSearch}><Search /></Button>
                <Button variant='dark' title='Limpiar' onClick={handleClear}><XSquare /></Button>
            </ButtonGroup>
        </div>
    );
}

export default FiltrosClientes;
